import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
            <footer className="text-center mt-3">
                 2021-2022 &copy; by <a target="-blank" href="https://www.facebook.com/farhan.nahid.01">
                 Farhan Ahmed Nahid </a> . All Rights Reserved.
             </footer>
    );
};

export default Footer;